import {Component, Input, Output, EventEmitter, ViewChild, ElementRef} from "@angular/core";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent {

  @Input() public url: string;
  @Input() public maxSize: number;
  @Input() public reuse: boolean = false;

  @Output() onSuccess = new EventEmitter<any>();
  @Output() onError = new EventEmitter<any>();

  @ViewChild("file") fileInput: ElementRef;

  authorization: string = 'Authorization';
  tokenName: string = 'heyground-token';
  tokenPrefix: string = 'Bearer ';

  enabled: boolean = false;
  status: string = 'WAITING';

  constructor() {
    if (FileUploadComponent.getIeVersion() > 9) {
      this.enabled = true;
    }
  }

  onClick() {
    if(!this.enabled) {
      window.alert('파일을 업로드할 수 없습니다.');
      return;
    }
    if(status == 'TRANSFER') {
      window.alert('파일을 전송 중입니다.');
      return;
    }

    this.fileInput.nativeElement.click();
  }

  fileChangeEvent(fileInput: any) {
    if (!fileInput.target.files) return;

    this.makeFileRequest(this.url, fileInput.target.files).then(
      (result) => {
        this.status = (this.reuse) ? 'WAITING' : 'COMPLETE';
        this.onSuccess.emit(result['filename']);
      },
      (error) => {
        this.status = 'ERROR';
        this.onError.emit(error)
      }
    );
  }

  makeFileRequest(url: string, files: Array<File>) {
    return new Promise((resolve, reject) => {
      if (files.length == 0) return;

      if(this.maxSize && files[0].size > this.maxSize) {
        window.alert(`파일 크기가 큽니다. 최대 가능 크기(${this.maxSize / 1048576}MB)`);
        return;
      }

      let token = JSON.parse(localStorage.getItem(this.tokenName));
      if (!token) {
        reject("need login");
      }

      this.status = 'TRANSFER';

      let formData: any = new FormData();
      formData.append("file", files[0], files[0].name);

      let xhr = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr);
          }
        }
      };
      xhr.onerror = () => {
        this.status = 'ERROR';
      };
      xhr.open("POST", environment.apiServer + url, true);
      // ie11에서는 open 후에 timeout을 설정해야 한다.
      xhr.timeout = 10000;
      xhr.ontimeout = () => {
        this.status = 'ERROR';
      };
      xhr.setRequestHeader(this.authorization, this.tokenPrefix + token.access_token);
      xhr.send(formData);
    });
  }

  static getIeVersion(): number {
    let rv = 100;
    if (navigator.appName == 'Microsoft Internet Explorer') {
      let ua = navigator.userAgent;
      let re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
      if (re.exec(ua) != null)
        rv = parseFloat(RegExp.$1);
    }
    return rv;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/file-upload/file-upload.component.ts